export const currencies = {
    NGN: {
      currency: 'Naira',
      sign: '₦',
      short: 'NGN',
    },
    GBP: {
      currency: 'Pounds',
      sign: '£',
      short: 'GBP',
    },
    EUR: {
      currency: 'Euros',
      sign: '€',
      short: 'EUR',
    },
    USD: {
      currency: 'US Dollars',
      sign: '$',
      short: 'USD',
    },
};